import { DatePipe, DecimalPipe } from '@angular/common';
import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { DealPagedRequest, DealPayment, FlowType, PaymentMethod, PaymentsPagedRequest } from '../model';
import { ActivatedRoute } from '@angular/router';
import { DealService } from '../deal.service';
import { DealTypePipe } from '../pipes/deal-type.pipe';
import { SelectModule } from 'primeng/select';
import { MultiSelectModule } from 'primeng/multiselect';
import { DatePickerModule } from 'primeng/datepicker';
import { FormsModule } from '@angular/forms';
import { BoolPipe } from '../pipes/bool.pipe';
import { PaymenMethodPipe } from '../pipes/payment-method.pipe';
import { CheckboxModule } from 'primeng/checkbox';
import { InputNumberModule } from 'primeng/inputnumber';
import { IconField, IconFieldModule } from 'primeng/iconfield';
import { InputIcon, InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { debounceTime, Subject } from 'rxjs';

@Component({
  selector: 'app-payment-list',
  imports: [
    FormsModule,
    TableModule, ButtonModule,
    DatePipe, DealTypePipe, DecimalPipe, BoolPipe, PaymenMethodPipe,
    SelectModule, CheckboxModule, InputNumberModule, IconFieldModule, InputIconModule,
    MultiSelectModule, DatePickerModule, InputTextModule
  ],
  templateUrl: './payment-list.component.html',
  styleUrl: './payment-list.component.scss'
})
export class PaymentListComponent {
  rangeDates: (Date | undefined)[] = [new Date(`${new Date().getFullYear()}-01-01`), new Date()];

  public req: PaymentsPagedRequest = {
    page: 0,
    pageSize: 20,
    types: [FlowType.NEW_CUSTOMER, FlowType.RENEWAL],
    paymentMethods: [],
    includeCompleted: false,
    includeScheduled: true,
    includeFailed: false,
    includeNotScheduled: false,
    includeProcessing: true,
    includePending: true,
    failedAttemptsFrom: undefined,
    failedAttemptsTo: undefined,
  };

  private searchChanged: Subject<string> = new Subject<string>();

  public dealTypes: any = [
    { name: 'NEW CUSTOMER', value: FlowType.NEW_CUSTOMER },
    { name: 'RENEWAL', value: FlowType.RENEWAL },
    { name: 'OVERDUE', value: FlowType.OVERDUE },
    { name: 'UPSELLING', value: FlowType.UPSELLING }
  ];

  public paymentMethods: any = [
    { name: 'Empty', value: PaymentMethod.None },
    { name: 'CARD', value: PaymentMethod.CreditCard },
    { name: 'IBAN', value: PaymentMethod.BankAcount }
  ];

  protected data: DealPayment[] = [];
  protected total: number = 0;
  protected isLoading: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private service: DealService
  ) {

  }

  ngOnInit(): void {
    this.activatedRoute.url.subscribe(url => {
      const path = url[1].path;
    });

    this.searchChanged.pipe(
      debounceTime(600) // ⏱ debounce delay in ms
    ).subscribe((term) => {
      this.refresh();
    });
  }

  onInputChange(term: string) {
    this.searchChanged.next(term);
  }

  refresh() {
    this.loadDataLazy({ first: 0 });
  }

  loadDataLazy(ev: TableLazyLoadEvent) {
    this.req.orderBy = ev.sortField as string;
    this.req.orderASC = ev.sortOrder == 1;

    this.req.from = this.rangeDates != null && this.rangeDates.length > 0 ? this.rangeDates[0] : undefined;
    this.req.to = this.rangeDates != null && this.rangeDates.length > 1 ? this.rangeDates[1] : undefined;

    this.service.allPayments({
      orderBy: this.req.orderBy,
      orderASC: this.req.orderASC,
      types: this.req.types,
      from: this.req.from,
      to: this.req.to,
      filter: this.req.filter,
      paymentMethods: this.req.paymentMethods,
      includeCompleted: this.req.includeCompleted,
      includeScheduled: this.req.includeScheduled,
      includeFailed: this.req.includeFailed,
      includePending: this.req.includePending,
      includeNotScheduled: this.req.includeNotScheduled,
      includeProcessing: this.req.includeProcessing,
      failedAttemptsFrom: this.req.failedAttemptsFrom,
      failedAttemptsTo: this.req.failedAttemptsTo,
      pageSize: this.req.pageSize,
      page: (ev.first ?? 0) / this.req.pageSize,
    }).subscribe(data => {
      this.data = data.items;
      this.total = data.total;
    });
  }

  exportData(): void {
    this.service.exportPayments(this.req).subscribe((response: Blob) => {
      const url = window.URL.createObjectURL(response);
      const a = document.createElement('a');
      a.href = url;
      a.download = `data.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    });
  }
}
